import React, { useState } from "react";
import Utils from "../tools/Utils";

const Form = (props) => {
    const [wasValidated, setWasValidated] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (e.target.checkValidity() === false) {
            Utils.Toast.fire({
                icon: 'error',
                text: 'Faltan campos obligatorios por llenar'
            });
            setWasValidated('was-validated');
            return;
        }

        setWasValidated('');
        props.submitCallback();
    }

    return(
        <form onSubmit={handleSubmit} className={`needs-validation ${wasValidated}`} noValidate>
            {props.children}
        </form>
    )
}

export default Form;